const INITIAL_STATE = {
  /**
   * Note: This is kept in redux, so we persist it between sessions...
   */
  archiveAdmissionReminderDismissed: false,
};

export const model = {
  name: "dashboard",

  state: INITIAL_STATE,

  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    dismissArchiveAdmissionReminder: state => ({
      ...state,
      archiveAdmissionReminderDismissed: true,
    }),
  },

  selectors: () => ({
    archiveAdmissionReminderDismissed: () => state =>
      state.dashboard.archiveAdmissionReminderDismissed,
  }),
};
